import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-speaker',
	templateUrl   : './speaker.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class SpeakerComponent implements OnInit {
	@Input() speakerData : any;
	/* for data from list & filter */
	public speakerList   : any;
	public speakerTags              : any = [];
	public speakerContinents        : any = [];
	public speakerOrgType           : any = [];
	public speakerJobTitle          : any = [];
	public speakerYoungProfessional : any = [];
	public speakerGender            : any = [];
	public speakerOpenToInterview   : any = [];
	public speakerAvailableSpeaker  : any = [];
	public speakerOpenToMeeting     : any = [];
	public tag_list_name            : any = [];
	public tag_list_id              : any = [];
	public noFilter                 : boolean = true; 
	public showSelectedorgtype      : boolean = false;
	public showSelectedcontinent    : boolean = false;
	public showSelectedjobtitle     : boolean = false;
	public showSelectedprofessional : boolean = false;
	public showSelectedgender       : boolean = false;
	public showSelectedinterview    : boolean = false;
	public showSelectedspeaker      : boolean = false;
	public showSelectedmeeting      : boolean = false;
	public showSelectedtag          : boolean = false;	
	public orgtypeAll               : boolean = true;
	public continentAll             : boolean = true;
	public jobtitleAll              : boolean = true;
	public professionalAll          : boolean = true;
	public genderAll                : boolean = true;
	public interviewAll             : boolean = true;
	public speakerAll               : boolean = true;
	public meetingAll               : boolean = true;
	public tagAll                   : boolean = true;
	public loadMoreButton           : boolean = true;
	public showMoreButton           : boolean = true;
	public filterButton             : boolean = false;
	public show_detail_page         : boolean = false;
	/* show selected tag name */
	public org_type_name     : any;
	public org_type_id       : number;
	public continent_name    : any;
	public continent_id      : number;
	public job_title         : any;
	public job_id            : number;
	public professional_name : any;
	public professional_id   : number;
	public gender_name       : any;
	public gender_id         : number;
	public interview_name    : any;
	public interview_id      : number;
	public speaker_name      : any;
	public speaker_id        : number;
	public meeting_name      : any;
	public meeting_id        : number;
	public action            : any = 'listing';
	public total             : number;
	public count             : any;
	public org_slug          : any;

	constructor(
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,
	) {
		smoothscroll.polyfill();
		this.funcs.globalLocalStorageHttp();
		var userData = this.funcs.globalSetUserSession();
		if ( userData )
			this.shareddata.setUserSession( userData );		
		let params = {
			'offset' : 0,
		}
		if ( 'filterSpeakers' in window.sessionStorage ) {
			if ( 'filterClick' in window.localStorage ) {
				let localSpeakersSessionItems = JSON.parse( sessionStorage.getItem( 'filterSpeakers' ) );
				localSpeakersSessionItems.offset = params.offset;
				sessionStorage.setItem( 'filterSpeakers', JSON.stringify( localSpeakersSessionItems ) );
				if ( 0 != localSpeakersSessionItems.tag_id ) {
					this.noFilter = false;
					this.showSelectedtag = true;
					this.tagAll = false;
					if ( 1 < localSpeakersSessionItems.tag_count ) {
						var tag_array = localSpeakersSessionItems.filter_id.split( ',' );
						tag_array.forEach( ( item, index ) => {
		                    this.tag_list_id.push( item );
		                });
						var tag_name_array = localSpeakersSessionItems.tag_names.split( ',' );
						tag_name_array.forEach( ( item, index ) => {
		                    this.tag_list_name.push( item );
		                });
					} else {
						this.tag_list_name.push( localSpeakersSessionItems.tag_names );
						this.tag_list_id.push( localSpeakersSessionItems.tag_id );
					}
				}
				if ( 0 != localSpeakersSessionItems.org_type_id ) {
					this.noFilter = false;
					this.showSelectedorgtype = true;
					this.orgtypeAll = false;
					this.org_type_name = localSpeakersSessionItems.org_type_name;
					this.org_type_id   = localSpeakersSessionItems.org_type_id;
				}
				if ( 0 != localSpeakersSessionItems.continent_id ) {
					this.noFilter = false;
					this.showSelectedcontinent = true;
					this.continentAll = false;
					this.continent_name = localSpeakersSessionItems.continent_name;
					this.continent_id   = localSpeakersSessionItems.continent_id;
				}
				if ( 0 != localSpeakersSessionItems.job_id ) {
					this.noFilter = false;
					this.showSelectedjobtitle = true;
					this.jobtitleAll = false;
					localSpeakersSessionItems.job_id = localSpeakersSessionItems.job_id;
					localSpeakersSessionItems.job_title = localSpeakersSessionItems.job_title;
					this.job_id = localSpeakersSessionItems.job_id;
					this.job_title = localSpeakersSessionItems.job_title = localSpeakersSessionItems.job_title;
				}
				if ( 0 != localSpeakersSessionItems.professional_id ) {
					this.noFilter = false;
					this.showSelectedprofessional = true;
					this.professionalAll = false;
					this.professional_name = localSpeakersSessionItems.professional_name;
					this.professional_id   = localSpeakersSessionItems.professional_id;
				}
				if ( 0 != localSpeakersSessionItems.gender_id ) {
					this.noFilter = false;
					this.showSelectedgender = true;
					this.genderAll = false;
					this.gender_name = localSpeakersSessionItems.gender_name;
					this.gender_id   = localSpeakersSessionItems.gender_id;
				}
				if ( 0 != localSpeakersSessionItems.interview_id ) {
					this.noFilter = false;
					this.showSelectedinterview = true;
					this.interviewAll = false;
					this.interview_name = localSpeakersSessionItems.interview_name;
					this.interview_id = localSpeakersSessionItems.interview_id;
				}
				if ( 0 != localSpeakersSessionItems.speaker_id ) {
					this.noFilter = false;
					this.showSelectedspeaker = true;
					this.speakerAll = false;
					this.speaker_name = localSpeakersSessionItems.speaker_name;
					this.speaker_id   = localSpeakersSessionItems.speaker_id;
				}
				if ( 0 != localSpeakersSessionItems.meeting_id ) {
					this.noFilter = false;
					this.showSelectedmeeting = true;
					this.meetingAll = false;
					this.meeting_name = localSpeakersSessionItems.meeting_name;
					this.meeting_id   = localSpeakersSessionItems.meeting_id;
				}				
				this.getFilterData( params, localSpeakersSessionItems, 'filter' );
			} else {
				sessionStorage.removeItem( 'filterSpeakers' );
				sessionStorage.removeItem( 'defaultSpeakerList' );
				sessionStorage.removeItem( 'speakerOrgType' );
				sessionStorage.removeItem( 'speakerContinents' );
				sessionStorage.removeItem( 'speakerJobTitle' );
				sessionStorage.removeItem( 'speakerYoungProfessional' );
				sessionStorage.removeItem( 'speakerGender' );
				sessionStorage.removeItem( 'speakerOpenToInterview' );
				sessionStorage.removeItem( 'speakerAvailableSpeaker' );
				sessionStorage.removeItem( 'speakerOpenToMeeting' );
				sessionStorage.removeItem( 'filterSpeakerTags' );
				this.defaultLoad( params );
			}
		} else { // default loading
			this.defaultLoad( params );
		}
	}

	defaultLoad( params ) {
		Promise.all( [ this.accountService.getSpeakers( params ) ] ).then( result => {
			if ( result[0]['status'] == 'Ok' ) {
				this.speakerList              = result[0]['speakers'];
				this.speakerOrgType           = result[0]['orgtype'];
				this.speakerContinents        = result[0]['continents'];
				this.speakerJobTitle          = result[0]['jobtitle'];
				this.speakerYoungProfessional = result[0]['youngprofessional'];
				this.speakerGender            = result[0]['genderlist'];
				this.speakerOpenToInterview   = result[0]['opentointerview'];
				this.speakerAvailableSpeaker  = result[0]['availablespeaker'];
				this.speakerOpenToMeeting     = result[0]['opentomeetingrequests'];
				this.speakerTags              = result[0]['tags'];
				/* add to sessionStorage */
				let myObj = {
					offset    : params.offset,
					org_type_id       : 0, /* orgtype id of current clicked orgtype */
					org_type_name     : '', /* orgtype name of current clicked orgtype */
					continent_id      : 0, /* continents id of current clicked continents */
					continent_name    : '', /* continents name of current clicked continents */
					job_id            : 0,
					job_title          : '',
					professional_id     : 0, /* youngprofessional Value of current clicked youngprofessional*/
					gender_id : 0,
					gender_name : '',
					professional_name   : '', /* youngprofessional key of current clicked youngprofessional*/
					interview_id    : false, /* if open to interview or not */
					interview_name : '',
					speaker_id : false, /* if availablespeaker or not */
					speaker_name : '',
					meeting_id      : false, /* if opentomeetingrequests or not*/
					meeting_name : '',
					tag_id            : 0, /* tag id of current clicked tag */
					tag_names         : '', /* tag names of current clicked tag */
					filter_id         : 0, /* add tag id as array for multiple */
					tag_count         : 0, /* count how many tags clicked(tags only) */
					limit             : result[0]['listLimit'],
				};
				sessionStorage.setItem( 'filterSpeakers', JSON.stringify( myObj ) );
				sessionStorage.setItem( 'defaultSpeakerList', JSON.stringify( { default_list : this.speakerList } ) );
				sessionStorage.setItem( 'speakerOrgType', JSON.stringify( { speaker_org_types : this.speakerOrgType } ) );
				sessionStorage.setItem( 'speakerContinents', JSON.stringify( { speaker_continents : this.speakerContinents } ) );
				sessionStorage.setItem( 'speakerJobTitle', JSON.stringify( { speaker_job_title : this.speakerJobTitle } ) );
				sessionStorage.setItem( 'speakerYoungProfessional', JSON.stringify( { speaker_professional : this.speakerYoungProfessional } ) );
				sessionStorage.setItem( 'speakerGender', JSON.stringify( { speaker_gender : this.speakerGender } ) );
				sessionStorage.setItem( 'speakerOpenToInterview', JSON.stringify( { speaker_interview : this.speakerOpenToInterview } ) );
				sessionStorage.setItem( 'speakerAvailableSpeaker', JSON.stringify( { speaker_speaker : this.speakerAvailableSpeaker } ) );
				sessionStorage.setItem( 'speakerOpenToMeeting', JSON.stringify( { speaker_meeting : this.speakerOpenToMeeting } ) );
				sessionStorage.setItem( 'filterSpeakerTags', JSON.stringify( { speaker_tags : this.speakerTags } ) );
				let count = this.speakerList.length;
				if ( count >= result[0]['listLimit'] )
					this.showMoreButton = true;
				else
					this.showMoreButton = false;
				this.total = result[0]['unfilteredTotalCount'];
				this.ngAfterViewInit();
			}
			this.loadMoreButton = false;
			this.org_slug = 'community/participant/';
		});
	}

	ngOnInit() {}

	ngAfterViewInit() {
		setTimeout (
			() => {
				this.addMasonry();
			}, 900
		);
		if ( ! document.querySelector( 'body' ).classList.contains( 'body-community-page' ) )
			document.querySelector( 'body' ).classList.add( 'body-community-page' );
	}

	onResize(event) {
		this.addMasonry();
	}

	addMasonry() {
		if ( document.querySelector( '.participants-grid' ) ) {
			var speElem = document.querySelector( '.participants-grid' );
			var speElemmsnry = new Masonry( speElem, {
				itemSelector: '.participants-grid-item',
				columnWidth: '.grid-sizer-3',
				horizontalOrder: true,
				percentPosition: true,
			});
			imagesLoaded( speElem ).on( 'progress', function() {
				speElemmsnry.layout();
			});
		}
	}

	loadMoreSpeaker() {
		this.loadMoreButton = true;
		this.showMoreButton = false;
		let localSpeakersSessionItems = JSON.parse( sessionStorage.getItem( 'filterSpeakers' ) );
		let next_offset   = parseInt( localSpeakersSessionItems.offset ) + parseInt( localSpeakersSessionItems.limit );
		let params = {
			'offset' : next_offset,
		};
		localSpeakersSessionItems.offset = next_offset;
		sessionStorage.setItem( 'filterSpeakers', JSON.stringify( localSpeakersSessionItems ) );
		Promise.all( [ this.accountService.getSpeakers( params ) ] ).then( result => {
			if ( result[0]['status'] == 'Ok' ) {
				for ( let value of result[0]['speakers'] )
					this.speakerList.push( value );							
				this.speakerOrgType           = result[0]['orgtype'];
				this.speakerContinents        = result[0]['continents'];
				this.speakerJobTitle          = result[0]['jobtitle'];
				this.speakerYoungProfessional = result[0]['youngprofessional'];
				this.speakerGender            = result[0]['genderlist'];
				this.speakerOpenToInterview   = result[0]['opentointerview'];
				this.speakerAvailableSpeaker  = result[0]['availablespeaker'];
				this.speakerOpenToMeeting     = result[0]['opentomeetingrequests'];
				this.speakerTags              = result[0]['tags'];
				let count = this.speakerList.length;							
				if ( result[0]['speakers'].length >= result[0]['listLimit'] )
					this.showMoreButton = true;
				else
					this.showMoreButton = false;
				this.total = result[0]['unfilteredTotalCount'];
				this.ngAfterViewInit();
			}
			this.loadMoreButton = false;
		});
	}

	filterMore( event : any, filter_type, filter_id, filter_name ) {
		this.filterButton = true;
		this.noFilter = false;
		let localSpeakersSessionItems;
		window.localStorage.setItem( 'filterClick', 'true' );
		if( event.target.classList.contains( 'activated' ) )
			this.removeFilter( event, filter_type, filter_id, filter_name );
		else {
			localSpeakersSessionItems = JSON.parse( sessionStorage.getItem( 'filterSpeakers' ) );
			if ( 'tags' == filter_type ) {
				var tag_id;
				var tag_name;
				if ( 0 != filter_id ) {
					this.showSelectedtag = true;
					this.tagAll = false;
					tag_id = localSpeakersSessionItems.filter_id;
					if ( tag_id != 0) {
						localSpeakersSessionItems.tag_count = localSpeakersSessionItems.tag_count + 1;
						tag_id = tag_id + ',' + filter_id;
						tag_name = localSpeakersSessionItems.tag_names + ',' + filter_name;
					} else {
						localSpeakersSessionItems.tag_count = 1;
						tag_id = filter_id;
						tag_name = filter_name;
					}
					this.tag_list_name.push( filter_name );
					this.tag_list_id.push( filter_id );
				} else {
					this.showSelectedtag = false;
					this.tagAll = true;
					tag_id = filter_id;
					localSpeakersSessionItems.tag_count = 0;
					this.tag_list_id = [];
					this.tag_list_name = [];
				}
				localSpeakersSessionItems.filter_id = tag_id;
				localSpeakersSessionItems.tag_id = filter_id;
				localSpeakersSessionItems.tag_names = tag_name;
			} else if( 'orgtype' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedorgtype = true;
					this.orgtypeAll = false;
					localSpeakersSessionItems.org_type_id = filter_id;
					localSpeakersSessionItems.org_type_name = filter_name;
					this.org_type_name = filter_name;
					this.org_type_id   = filter_id;
				} else {
					this.showSelectedorgtype = false;
					this.orgtypeAll = true;
					localSpeakersSessionItems.org_type_id = 0;
					localSpeakersSessionItems.org_type_name = '';
					this.org_type_name = '';
					this.org_type_id   = 0;
				}
			} else if( 'continent' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedcontinent = true;
					this.continentAll = false;
					localSpeakersSessionItems.continent_id = filter_id;
					localSpeakersSessionItems.continent_name = filter_name;
					this.continent_name = filter_name;
					this.continent_id   = filter_id;
				} else {
					this.showSelectedcontinent = false;
					this.continentAll = true;
					localSpeakersSessionItems.continent_id = 0;
					localSpeakersSessionItems.continent_name = '';
					this.continent_name = '';
					this.continent_id   = 0;
				}
			} else if( 'jobtitle' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedjobtitle = true;
					this.jobtitleAll = false;
					localSpeakersSessionItems.job_id = filter_id;
					localSpeakersSessionItems.job_title = filter_name;
					this.job_title = filter_name;
					this.job_id   = 1;
				} else {
					this.showSelectedjobtitle = false;
					this.jobtitleAll = true;
					localSpeakersSessionItems.job_id = 0;
					localSpeakersSessionItems.job_title = '';
					this.job_title = '';
					this.job_id   = 0;
				}
			} else if( 'professional' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedprofessional = true;
					this.professionalAll = false;
					localSpeakersSessionItems.professional_id = filter_id;
					localSpeakersSessionItems.professional_name = filter_name;
					this.professional_name = filter_name;
					this.professional_id   = filter_id;
				} else {
					this.showSelectedprofessional = false;
					this.professionalAll = true;
					localSpeakersSessionItems.professional_id = 0;
					localSpeakersSessionItems.professional_name = '';
					this.professional_name = '';
					this.professional_id   = 0;
				}
			} else if( 'gender' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedgender = true;
					this.genderAll = false;
					localSpeakersSessionItems.gender_id = filter_id;
					localSpeakersSessionItems.gender_name = filter_name;
					this.gender_name = filter_name;
					this.gender_id   = filter_id;
				} else {
					this.showSelectedgender = false;
					this.genderAll = true;
					localSpeakersSessionItems.gender_id = 0;
					localSpeakersSessionItems.gender_name = '';
					this.gender_name = '';
					this.gender_id   = 0;
				}
			} else if( 'interview' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedinterview = true;
					this.interviewAll = false;
					if ( true == filter_id )
						filter_id = 1;
					else
						filter_id = 2;
					localSpeakersSessionItems.interview_id = filter_id;
					localSpeakersSessionItems.interview_name = filter_name;
					this.interview_name = filter_name;
					this.interview_id   = filter_id;
				} else {
					this.showSelectedinterview = false;
					this.interviewAll = true;
					localSpeakersSessionItems.interview_id = 0;
					localSpeakersSessionItems.interview_name = '';
					this.interview_name = '';
					this.interview_id   = 0;
				}
			} else if( 'speaker' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedspeaker = true;
					this.speakerAll = false;
					if ( true == filter_id )
						filter_id = 1;
					else
						filter_id = 2;
					localSpeakersSessionItems.speaker_id = filter_id;
					localSpeakersSessionItems.speaker_name = filter_name;
					this.speaker_name = filter_name;
					this.speaker_id   = filter_id;
				} else {
					this.showSelectedspeaker = false;
					this.speakerAll = true;
					localSpeakersSessionItems.speaker_id = 0;
					localSpeakersSessionItems.speaker_name = '';
					this.speaker_name = '';
					this.speaker_id   = 0;
				}
			} else if( 'meeting' == filter_type) {
				if ( 0 != filter_id ) {
					this.showSelectedmeeting = true;
					this.meetingAll = false;
					if ( true == filter_id )
						filter_id = 1;
					else
						filter_id = 2;
					localSpeakersSessionItems.meeting_id = filter_id;
					localSpeakersSessionItems.meeting_name = filter_name;
					this.meeting_name = filter_name;
					this.meeting_id   = filter_id;
				} else {
					this.showSelectedmeeting = false;
					this.meetingAll = true;
					localSpeakersSessionItems.meeting_id = 0;
					localSpeakersSessionItems.meeting_name = '';
					this.meeting_name = '';
					this.meeting_id   = 0;
				}
			}
			let params = {
				'offset' : 0,
			};
			localSpeakersSessionItems.offset = params.offset;
			sessionStorage.setItem( 'filterSpeakers', JSON.stringify( localSpeakersSessionItems ) );
			this.getFilterData( params, localSpeakersSessionItems, 'filter' );
		}
	}

	removeFilter( event : any, filter_type, filter_id, filter_name  ) {
		this.filterButton = true;
		event.target.classList.remove( 'activated' );
		let localSpeakersSessionItems = JSON.parse( sessionStorage.getItem( 'filterSpeakers' ) );
		if ( 'tags' == filter_type ) {
			let tag_count = localSpeakersSessionItems.tag_count;
			if ( 1 < tag_count ) {
				(<HTMLInputElement>document.getElementById( 'tag-' + filter_id ) ).remove();
				var tag_array = localSpeakersSessionItems.filter_id.split( ',' );
				tag_array.forEach( ( item, index ) => {
                    if ( filter_id == item )
                    	tag_array.splice( index, 1 );
                });
                tag_array.join( ',' );
                localSpeakersSessionItems.filter_id = tag_array.toString();
				var tag_name_array = localSpeakersSessionItems.tag_names.split( ',' );
				tag_name_array.forEach( ( item, index ) => {
                    if ( filter_name == item )
                    	tag_name_array.splice( index, 1 );
                });
                tag_name_array.join( ',' );
                localSpeakersSessionItems.tag_names = tag_name_array.toString();
			} else {
				this.showSelectedtag = false;
				this.tagAll = true;
				localSpeakersSessionItems.tag_names = '';
				localSpeakersSessionItems.tag_id = 0;
				localSpeakersSessionItems.filter_id = 0;
				this.tag_list_id = [];
				this.tag_list_name = [];				
			}
			localSpeakersSessionItems.tag_count = tag_count - 1
		} else if( 'orgtype' == filter_type) {
			this.showSelectedorgtype = false;
			this.orgtypeAll = true;
			localSpeakersSessionItems.org_type_id = 0;
			localSpeakersSessionItems.org_type_name = '';
			this.org_type_name = '';
			this.org_type_id   = 0;
		} else if( 'continent' == filter_type) {
			this.showSelectedcontinent = false;
			this.continentAll = true;
			localSpeakersSessionItems.continent_id = 0;
			localSpeakersSessionItems.continent_name = '';
			this.continent_name = '';
			this.continent_id   = 0;
		} else if( 'jobtitle' == filter_type) {
			this.showSelectedjobtitle = false;
			this.jobtitleAll = true;
			localSpeakersSessionItems.job_id = 0;
			localSpeakersSessionItems.job_title = '';
			this.job_title = '';
			this.job_id   = 0;
		} else if( 'professional' == filter_type) {
			this.showSelectedprofessional = false;
			this.professionalAll = true;
			localSpeakersSessionItems.professional_id = 0;
			localSpeakersSessionItems.professional_name = '';
			this.professional_name = '';
			this.professional_id   = 0;
		} else if( 'gender' == filter_type) {
			this.showSelectedgender = false;
			this.genderAll = true;
			localSpeakersSessionItems.gender_id = 0;
			localSpeakersSessionItems.gender_name = '';
			this.gender_name = '';
			this.gender_id   = 0;
		} else if( 'interview' == filter_type) {
			this.showSelectedinterview = false;
			this.interviewAll = true;
			localSpeakersSessionItems.interview_id = 0;
			localSpeakersSessionItems.interview_name = '';
			this.interview_name = '';
			this.interview_id   = 0;
		} else if( 'speaker' == filter_type) {
			this.showSelectedspeaker = false;
			this.speakerAll = true;
			localSpeakersSessionItems.speaker_id = 0;
			localSpeakersSessionItems.speaker_name = '';
			this.speaker_name = '';
			this.speaker_id   = 0;
		} else if( 'meeting' == filter_type) {
			this.showSelectedmeeting = false;
			this.meetingAll = true;
			localSpeakersSessionItems.meeting_id = 0;
			localSpeakersSessionItems.meeting_name = '';
			this.meeting_name = '';
			this.meeting_id   = 0;
		}
		let params = {
			offset   : 0,
		};
		localSpeakersSessionItems.offset = params.offset;
		sessionStorage.setItem( 'filterSpeakers', JSON.stringify( localSpeakersSessionItems ) );
		this.getFilterData( params,  localSpeakersSessionItems, 'filter' );
	}

	getFilterData( params, localSpeakersSessionItems, action ) {
		this.loadMoreButton = true;
		this.showMoreButton = false;
		this.action = action;
		if ( 'filter' == this.action )
			document.getElementById( 'closeTagsSpeakers' ).click();
		this.accountService.getSpeakers( params ).then( ( dotnetresponse: any ) => {
			if ( dotnetresponse.status == 'Ok' ) {
				if ( 'filter' == action ) {
					this.speakerList = dotnetresponse.speakers;
				} else {
					if ( 0 == localSpeakersSessionItems.continent_id &&
						0 == localSpeakersSessionItems.filter_id &&
						0 == localSpeakersSessionItems.gender_id &&
						0 == localSpeakersSessionItems.interview_id &&
						0 == localSpeakersSessionItems.job_id &&
						0 == localSpeakersSessionItems.meeting_id &&
						0 == localSpeakersSessionItems.org_type_id &&
						0 == localSpeakersSessionItems.professional_id &&
						0 == localSpeakersSessionItems.speaker_id ) {
						/* no filter in session */
						this.action = 'listing';
						this.speakerList  = dotnetresponse.speakers;
					} else {
						this.action = 'filter';
						if( true == this.shareddata.loggedIn )
							this.speakerList = dotnetresponse.speakers;
						else
							this.speakerList = JSON.parse( sessionStorage.getItem( 'defaultSpeakerList' ) ).default_list;
					}
				}
				if ( false == this.shareddata.loggedIn && 'filter' == this.action )
					this.funcs.globalnonLoggedinUserMessage();
				this.speakerOrgType           = dotnetresponse.orgtype;
				this.speakerContinents        = dotnetresponse.continents;
				this.speakerJobTitle          = dotnetresponse.jobtitle;
				this.speakerYoungProfessional = dotnetresponse.youngprofessional;
				this.speakerGender            = dotnetresponse.genderlist;
				this.speakerOpenToInterview   = dotnetresponse.opentointerview;
				this.speakerAvailableSpeaker  = dotnetresponse.availablespeaker;
				this.speakerOpenToMeeting     = dotnetresponse.opentomeetingrequests;
				this.speakerTags              = dotnetresponse.tags;
				sessionStorage.removeItem( 'defaultSpeakerList' );
				sessionStorage.removeItem( 'speakerOrgType' );
				sessionStorage.removeItem( 'speakerContinents' );
				sessionStorage.removeItem( 'speakerJobTitle' );
				sessionStorage.removeItem( 'speakerYoungProfessional' );
				sessionStorage.removeItem( 'speakerGender' );
				sessionStorage.removeItem( 'speakerOpenToInterview' );
				sessionStorage.removeItem( 'speakerAvailableSpeaker' );
				sessionStorage.removeItem( 'speakerOpenToMeeting' );
				sessionStorage.removeItem( 'filterSpeakerTags' );
				sessionStorage.setItem( 'defaultSpeakerList', JSON.stringify( { default_list : this.speakerList } ) );
				sessionStorage.setItem( 'speakerOrgType', JSON.stringify( { participant_org_types : this.speakerOrgType } ) );
				sessionStorage.setItem( 'speakerContinents', JSON.stringify( { participant_continents : this.speakerContinents } ) );
				sessionStorage.setItem( 'speakerJobTitle', JSON.stringify( { participant_job_title : this.speakerJobTitle } ) );
				sessionStorage.setItem( 'speakerYoungProfessional', JSON.stringify( { participant_professional : this.speakerYoungProfessional } ) );
				sessionStorage.setItem( 'speakerGender', JSON.stringify( { participant_gender : this.speakerGender } ) );
				sessionStorage.setItem( 'speakerOpenToInterview', JSON.stringify( { participant_interview : this.speakerOpenToInterview } ) );
				sessionStorage.setItem( 'speakerAvailableSpeaker', JSON.stringify( { participant_speaker : this.speakerAvailableSpeaker } ) );
				sessionStorage.setItem( 'speakerOpenToMeeting', JSON.stringify( { participant_meeting : this.speakerOpenToMeeting } ) );
				sessionStorage.setItem( 'filterSpeakerTags', JSON.stringify( { participant_tags : this.speakerTags } ) );
				let count = this.speakerList.length;
				if ( count >= dotnetresponse.listLimit )
					this.showMoreButton = true;
				else
					this.showMoreButton = false;
				if ( 0 == localSpeakersSessionItems.continent_id &&
						0 == localSpeakersSessionItems.filter_id &&
						0 == localSpeakersSessionItems.gender_id &&
						0 == localSpeakersSessionItems.interview_id &&
						0 == localSpeakersSessionItems.job_id &&
						0 == localSpeakersSessionItems.meeting_id &&
						0 == localSpeakersSessionItems.org_type_id &&
						0 == localSpeakersSessionItems.professional_id &&
						0 == localSpeakersSessionItems.speaker_id
				)
					this.count = '';
				 else
					this.count = dotnetresponse.totalCount + ' of ';				
				this.total = dotnetresponse.unfilteredTotalCount;
				this.ngAfterViewInit();
			}
			this.loadMoreButton = false;
			this.filterButton = false;
		});
	}
}